const GEOJSON_URL =
	'https://raw.githubusercontent.com/codeforgermany/click_that_hood/main/public/data/brazil-states.geojson';

export type GeoFeature = {
	type: 'Feature';
	properties: Record<string, unknown> | null;
	geometry: unknown;
};

export type BrazilGeoJSON = {
	type: 'FeatureCollection';
	features: GeoFeature[];
};

let _cache: BrazilGeoJSON | null = null;
let _promise: Promise<BrazilGeoJSON> | null = null;

export function loadBrazilGeoJSON(): Promise<BrazilGeoJSON> {
	if (_cache) return Promise.resolve(_cache);
	if (!_promise) {
		_promise = fetch(GEOJSON_URL)
			.then((r) => r.json() as Promise<BrazilGeoJSON>)
			.then((data) => {
				_cache = data;
				return data;
			});
	}
	return _promise;
}

export function getCachedBrazilGeoJSON(): BrazilGeoJSON | null {
	return _cache;
}
